import request from '@/utils/request'

// 发送思念给对方
export function sendMiss (data) {
  // data: { intensity: 1, message?: string }
  return request.post('/miss/send', data)
}

// 确认收到思念
export function confirmReceived (data) {
  // data: { clearAmount: number, isComplete: boolean }
  return request.post('/miss/confirm', data)
}

// 获取当前用户的思念状态
export function getMissStatus () {
  return request.get('/miss/status')
}

// 注意：其他统计、历史、设置相关API已删除
// 当前只保留核心的3个API，满足极简交互需求
